import { OrderData, ShoppingCartData } from '../../../data/model';
import { CheckoutEventData, PurchaseEventData } from '../types';
import { ProductDataConverter } from './ProductDataConverter';

export class CheckoutEventDataConverter {
  public static fromShoppingCartData(cart: ShoppingCartData, discountCode?: string): CheckoutEventData {
    return {
      currency: cart.subTotalWithTax.currency.code,
      discountCode,
      products: cart.items.map((item) => ProductDataConverter.fromShoppingCartItemData(item, discountCode)),
      value: cart.totalWithTax.amount,
    };
  }

  public static fromOrderData(order: OrderData, discountCode?: string): PurchaseEventData {
    return {
      currency: order.subTotalWithTax.currency.code,
      discountCode,
      orderNumber: order.number,
      products: order.items.map((item) => ProductDataConverter.fromOrderItemData(item, discountCode)),
      shipping: order.totalShippingWithTax.amount,
      tax: order.taxTotal.amount,
      value: order.totalWithTax.amount,
    };
  }
}
